import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { redirect } from 'redux-first-router';

import {
  ACTION_REQUEST_RESEND_CODE,
  ACTION_REQUEST_VERIFY_OTP,
  REQUEST_RESEND_OTP_FAILURE,
  REQUEST_RESEND_OTP_SUCCESS,
  REQUEST_VERIFY_OTP_FAILURE,
  REQUEST_VERIFY_OTP_SUCCESS,
  resendOTPAPI,
  verifyOTPAPI,
} from '.';
import { showToastAlert } from '../app';
import { ROUTE_LOGIN } from '../routing';
import {
  removeRefCookie,
  removeTemporaryAuthToken,
  setTemporaryAuthToken,
} from '../../../utils/localStorage';

function* loadRouteData() {
  // Allow users to access OTP page even without token
  // They can resend OTP to get a new token
  // The verify OTP will handle the token check when they submit
  yield; // Generator function needs at least one yield
}

function* verifyOTP() {
  yield takeLatest([ACTION_REQUEST_VERIFY_OTP], function* (action) {
    yield put(verifyOTPAPI(action.payload));
  });

  yield takeLatest([REQUEST_VERIFY_OTP_SUCCESS], function* () {
    //  remove temporary token
    removeTemporaryAuthToken();
    // remove ref cookie after successful OTP verification
    removeRefCookie();
    yield put(
      redirect({
        type: ROUTE_LOGIN,
      })
    );
    yield put(showToastAlert('Verify OTP successfully!', 'success'));
  });

  yield takeLatest([REQUEST_VERIFY_OTP_FAILURE], function* (action) {
    const messageError = action?.payload?.data?.message;

    yield put(
      showToastAlert(messageError || action?.error?.message || 'Failed to verify OTP!', 'error')
    );
  });
}

function* resendOTP() {
  yield takeLatest([ACTION_REQUEST_RESEND_CODE], function* (action) {
    yield put(resendOTPAPI(action.payload));
  });

  yield takeLatest([REQUEST_RESEND_OTP_SUCCESS], function* (action) {
    // Check if backend returns token in response
    const token = action?.payload?.data?.token || action?.payload?.data || action?.payload?.token;
    if (token) {
      setTemporaryAuthToken(token);
    }
    yield put(showToastAlert('Resend OTP successfully!', 'success'));
  });

  yield takeLatest([REQUEST_RESEND_OTP_FAILURE], function* (action) {
    const messageError = action?.payload?.data?.message;

    yield put(
      showToastAlert(messageError || action?.error?.message || 'Failed to resend OTP!', 'error')
    );
  });
}

export default function* loadOTPVerification() {
  yield all([fork(loadRouteData), fork(verifyOTP), fork(resendOTP)]);
}
